import { FC } from "react";
import { AdminAccounts } from "../../../modules/admin/components/screens/admin-accounts/admin-accounts";

export const AdminAccountsRoute: FC = () => {
    return (
        <AdminAccounts />
    )
}